module.exports = __webpack_public_path__ + "static/img/46.61df96e4.gif";